import { SimulationBuildingItemRes } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 労務山積計算-物件情報取得API
 */
export class BuildingItemGateway {
  static getSimulationBuildingItem = async (
    simulationYm: string,
    procurementNo: string,
    subNo: string,
    branchCd: string,
    expense: string,
    expenseSeq: string
  ) => {
    return await yamadumiApi.get<SimulationBuildingItemRes>(
      '/api/simulation/building/item',
      { simulationYm, procurementNo, subNo, branchCd, expense, expenseSeq }
    )
  }
}
